import React from "react";

import "./quickChargeTabModal.scss";
import { LocaleCurrency } from "helpers/Locale";

interface IPriceDisplayProps {
  label: string;
  currency: string;
  amount: number;
}

export default function PriceDisplay(props: IPriceDisplayProps) {
  const { label, currency, amount } = props;

  return (
    <div className="flex flex-row justify-between">
      <p>{label}</p>

      <LocaleCurrency currency={currency ?? "cad"} amount={amount} />
    </div>
  );
}
